import type { JSX } from "react";

import { PAGE_META } from "./content.js";
import { LegalPage } from "./LegalPage.js";
import { PRIVACY_POLICY } from "./legal-content.js";

/** `/privacy` — the Privacy Policy for the portal (2026-09-14). */
export function PrivacyPage(): JSX.Element {
  return <LegalPage content={PRIVACY_POLICY} meta={PAGE_META.privacy} />;
}
